import { useLocalStorage } from '@rehooks/local-storage';

const STORAGE_KEY = 'dci-settings-user-ui';

export function clear() {
  localStorage.removeItem(STORAGE_KEY);
}

export function restore(defaultValue) {
  const payload = localStorage.getItem(STORAGE_KEY);

  if (typeof payload === 'string') {
    try {
      return JSON.parse(payload);
    } catch (_) {
      clear();
    }
  }

  return defaultValue;
}

export function store(data) {
  const payload = JSON.stringify(data);
  localStorage.setItem(STORAGE_KEY, payload);
}

export function useMemory() {
  return useLocalStorage(STORAGE_KEY, {});
}
